import React from 'react';
import ReactDOM from 'react-dom';
import 'core-js';
import styles from './index.css';
import PropTypes from 'prop-types';
import { rel } from '../../../../../utils/rel';
import { getPicRecom } from '../../../../../services/api';
import errorBoundary from '@ifeng/errorBoundary';
import Ad from '@ifeng/ui_pc_ad';

class PicOver extends React.PureComponent {
    state = {
        jsSpan: false,
        picRecomArr: [],
    };

    // 从推荐数组中随机获取6条
    getRandomArrayElements = (arr, count) => {
        const shuffled = arr.slice(0);
        let i = arr.length;
        const min = i - count;
        let temp = '';
        let index = 0;

        while (i-- > min) {
            index = Math.floor((i + 1) * Math.random());
            temp = shuffled[index];
            shuffled[index] = shuffled[i];
            shuffled[i] = temp;
        }

        return shuffled.slice(min);
    };

    // 点击换一换,随机展示6条数据
    picBoxChange = () => {
        const { picRecomData } = this.state;
        const picRecomArr = this.getRandomArrayElements(picRecomData, 6) || [];

        this.setState({ picRecomArr });
    };

    async componentDidMount() {
        const { picOverData } = this.props;
        const { channel, current } = picOverData;

        // 从接口获取图集推荐数据
        const result = await getPicRecom(channel);

        this.setState({ picRecomData: result });

        this.picBoxChange();

        window.location.hash = `#p=${current + 2}&_cpb_slide_last`;
    }
    /**
     * 渲染组件
     */
    render() {
        const { jsSpan, picRecomArr } = this.state;
        const { picOverData, handleOverPrev, handleOverNext } = this.props;

        const createList = () => (
            <ul>
                {picRecomArr.length > 1
                    ? picRecomArr.map((item, index) => (
                          <li key={index}>
                              <a href={item.url} rel={rel} target="_blank">
                                  <img src={item.img} alt={item.title} />
                              </a>
                              <a href={item.url} rel={rel} target="_blank">
                                  <p>
                                      <span style={{ display: 'none' }}>{item.publishTime}</span>
                                      {item.title}
                                  </p>
                              </a>
                          </li>
                      ))
                    : ''}
            </ul>
        );

        return (
            <div className={styles.over}>
                <a className={styles.overprev} onClick={handleOverPrev}>
                    <span>上一页</span>
                </a>
                <a className={styles.overnext} onClick={handleOverNext}>
                    <span>下一图集</span>
                </a>
                <div className={styles.overCon}>
                    <div className={styles.overConUl}>
                        <div className={styles.overTit}>
                            <p>推荐图集</p>
                            <a className={styles.picAgian} onClick={this.picBoxChange}>
                                换一组<span className={jsSpan ? styles.js_span : ''} />
                            </a>
                        </div>
                        <div>{createList()}</div>
                    </div>
                    <Ad content={picOverData.asideAd2} styleName={styles.overAd} />
                </div>
                <div className="bomAd" style={{ marginTop: '40px' }} />
            </div>
        );
    }
}
/**
 * 定义组件属性类型
 * */
PicOver.propTypes = {
    handleOverPrev: PropTypes.func,
    handleOverNext: PropTypes.func,
    picOverData: PropTypes.object,
};

/**
 * 定义组件默认属性
 * */
PicOver.defaultProps = {};

export { PicOver };
export default errorBoundary(PicOver);
